import * as React from "react";

import {
    ClientPublicCandidateActionTypes,
    useClientPublicCandidateActions,
} from "./candidate";
import { ClientPublicCandidateState } from "./clientPublicCandidateState";
import {
    ClientPublicCandidateUIActionTypes,
    useClientPublicCandidateUIActions,
} from "./ui";

export type CombinedClientPublicCandidateActionTypes =
    | ClientPublicCandidateUIActionTypes
    | ClientPublicCandidateActionTypes;

export const useCombinedClientPublicCandidateActions = (
    state: ClientPublicCandidateState,
    dispatch: React.Dispatch<CombinedClientPublicCandidateActionTypes>
) => {
    const uiActions = useClientPublicCandidateUIActions(state, dispatch);
    const candidateActions = useClientPublicCandidateActions(state, dispatch);
    return {
        ...uiActions,
        ...candidateActions,
    };
};

export type CombinedClientPublicCandidateActions = ReturnType<
    typeof useCombinedClientPublicCandidateActions
>;
